import { HabitCycleType, HabitTimeType, HabitType, type HabitWeekday } from "@fitness-app/data-models/entities/Habit";

// TRE-1656 — explicit "Nawyk" vs "Zadanie" split in the creation form.
export const habitTypeLabels: Record<HabitType, string> = {
  [HabitType.Single]: "Nawyk",
  [HabitType.Group]: "Nawyk z listą kontrolną",
  [HabitType.Task]: "Zadanie",
};

export const habitTypeColors: Record<HabitType, string> = {
  [HabitType.Single]: "blue",
  [HabitType.Group]: "geekblue",
  [HabitType.Task]: "purple",
};

export const habitCycleTypeLabels: Record<HabitCycleType, string> = {
  [HabitCycleType.Infinite]: "Bez końca",
  [HabitCycleType.UntilDate]: "Do daty",
  [HabitCycleType.CycleNumber]: "Liczba cykli",
};

export const habitTimeTypeLabels: Record<HabitTimeType, string> = {
  [HabitTimeType.AllDay]: "Cały dzień",
  [HabitTimeType.Hour]: "Konkretna godzina",
  [HabitTimeType.Range]: "Przedział godzin",
};

export const habitTypeOptions = Object.values(HabitType).map((value) => ({
  value,
  label: habitTypeLabels[value],
}));

export const habitCycleTypeOptions = Object.values(HabitCycleType).map((value) => ({
  value,
  label: habitCycleTypeLabels[value],
}));

export const habitTimeTypeOptions = Object.values(HabitTimeType).map((value) => ({
  value,
  label: habitTimeTypeLabels[value],
}));

// TRE-1584 — visual identity: palette keys shared with the mobile unistyles theme scales.
export const HABIT_COLOR_KEYS = ["gold", "green", "amber", "blue", "red"] as const;
export type HabitColorKey = (typeof HABIT_COLOR_KEYS)[number];

// Habit icons are lucide keys (TRE-1584) — the canonical set lives in data-models.
export { DEFAULT_HABIT_ICON_KEY as DEFAULT_HABIT_ICON } from "@fitness-app/data-models/domain/habitIcons";
export const DEFAULT_HABIT_COLOR: HabitColorKey = "gold";

export const habitColorLabels: Record<HabitColorKey, string> = {
  gold: "Złoty",
  green: "Zielony",
  amber: "Bursztynowy",
  blue: "Niebieski",
  red: "Czerwony",
};

/** Swatch hex used for the color-picker dots (roughly step 9 of each scale). */
export const habitColorHex: Record<HabitColorKey, string> = {
  gold: "#d4b106",
  green: "#30a46c",
  amber: "#ffb224",
  blue: "#0091ff",
  red: "#e5484d",
};

export const asHabitColor = (value: string | null | undefined): HabitColorKey =>
  (HABIT_COLOR_KEYS as readonly string[]).includes(value ?? "") ? (value as HabitColorKey) : DEFAULT_HABIT_COLOR;

// dayjs day() numbering: 0 = Sunday … 6 = Saturday. Ordered Pn…Nd for display.
export const weekdayOptions: { value: HabitWeekday; label: string }[] = [
  { value: 1, label: "Pn" },
  { value: 2, label: "Wt" },
  { value: 3, label: "Śr" },
  { value: 4, label: "Cz" },
  { value: 5, label: "Pt" },
  { value: 6, label: "So" },
  { value: 0, label: "Nd" },
];

export const allWeekdays = weekdayOptions.map((option) => option.value);

export const HABIT_TIME_FORMAT = "HH:mm";
